export type ChatEntryDomain = "dentistry" | "medicine";

/** Explicit entry parameters also support the already-published SMLE ad URLs. */
export function getChatEntry(search: string): { domain?: ChatEntryDomain; language: "en" | "ar" } {
  const params = new URLSearchParams(search);
  const campaign = params.get("utm_campaign") || "";
  const smleCampaign = /^smle_(en|ar)_\d{6}$/.exec(campaign);
  const requestedDomain = params.get("domain");
  return {
    domain: requestedDomain === "medicine" || requestedDomain === "dentistry"
      ? requestedDomain
      : smleCampaign ? "medicine" : undefined,
    language: params.get("lang") === "ar" || (!params.has("lang") && smleCampaign?.[1] === "ar") ? "ar" : "en",
  };
}

export function medicineChatPath(language: "en" | "ar"): string {
  return `/chat?domain=medicine&lang=${language}`;
}
